import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { type CategorySelectorState, MobileCategorySingleSelect, useInfoInitializeConfirmModal } from '@/views/build/features/category-select-view';
import { type CategoryNode, isNodeEmpty } from '@/views/build/features/category-tree';
export const SchoolTypeMobileSelection = ({
  categoryInfo
}: {
  categoryInfo: CategorySelectorState;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    openInfoInitializeConfirmModal
  } = useInfoInitializeConfirmModal();
  const handleValueChangeWithConfirm = useCallback(async (value: CategoryNode) => {
    const hasChildSelections = !isNodeEmpty(categoryInfo.grade.selectedGradeNode || categoryInfo.semester.selectedSemesterNode);
    if (hasChildSelections) {
      const confirmed = await openInfoInitializeConfirmModal();
      if (!confirmed) return;
    }
    categoryInfo.updateCategoryInfo(value);
  }, [categoryInfo, openInfoInitializeConfirmModal]);
  return <MobileCategorySingleSelect categoryNodes={categoryInfo.schoolType.schoolInfoNodes} value={categoryInfo.schoolType.selectedSchoolTypeNode?.nodeId || null} onValueChange={handleValueChangeWithConfirm} title={t('build:schoolInfo.schoolLevel')} placeholder={t('build:schoolInfo.schoolLevel')} error={!!categoryInfo.errors.schoolTypeId} helperText={categoryInfo.errors.schoolTypeId} data-sentry-element="MobileCategorySingleSelect" data-sentry-component="SchoolTypeMobileSelection" data-sentry-source-file="SchoolTypeMobileSelection.tsx" />;
};